module.exports = __webpack_public_path__ + "static/media/icon_internet.50455ad1.svg";